import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "jin"
};
const _hoisted_2 = {
  class: "bg-white m-2 rounded-lg p-4"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-lg mb-3"
}, "推荐组合", -1);
const _hoisted_4 = {
  class: "bg-white m-2 rounded-lg p-4"
};
const _hoisted_5 = {
  class: "flex justify-between items-center mb-3"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-lg"
}, "经咒内容", -1);
const _hoisted_7 = {
  class: "text-sm"
};
const _hoisted_8 = {
  class: "bg-white m-2 rounded-lg p-4"
};
const _hoisted_9 = {
  class: "flex justify-between items-center mb-3"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-lg"
}, "回向内容", -1);
const _hoisted_11 = {
  class: "text-sm"
};
const _hoisted_12 = {
  class: "bg-white m-2 rounded-lg p-4"
};
const _hoisted_13 = {
  class: "text-lg mb-3 font-medium"
};
const _hoisted_14 = {
  style: {
    "color": "#f66636"
  }
};
const _hoisted_15 = {
  class: "text-center pb-8"
};
import { Toast } from 'vant';
import { ref } from 'vue';
import router from '@/router';
import { useStore } from '@/stores/pinia';
import { computed } from '@vue/reactivity';
export default /*#__PURE__*/_defineComponent({
  __name: 'NianJing',
  setup(__props) {
    const store = useStore();
    const recommendList = ref([{
      label: '超度',
      list: ['四皈依', '观音心咒', '阿弥陀佛圣号', '解缚咒', '不动佛心咒', '大日如来心咒', '大圆满心咒（六道金刚咒）', '替身朵玛仪轨', '火施仪轨', '极乐愿文', '普贤行愿品', '金刚萨埵心咒']
    }, {
      label: '祈福',
      list: ['四皈依', '八吉祥颂', '怀业自在祈祷文', '二十一度母礼赞', '遣除道障祈祷文', '金刚萨埵心咒']
    }, {
      label: '健康',
      list: ['四皈依', '观音心咒', '阿弥陀佛圣号', '解缚咒', '不动佛心咒', '大日如来心咒', '大圆满心咒（六道金刚咒）།', '替身朵玛仪轨', '火施仪轨', '极乐愿文', '普贤行愿品 ', '药师佛心咒', '长寿佛心咒', '金刚萨埵心咒']
    }, {
      label: '事业',
      list: ['四皈依', '缘起咒', '怀业自在祈祷文', '作明佛母心咒', '二十一度母礼赞', '金刚萨埵心咒']
    }, {
      label: '生意',
      list: ['四皈依', '怀业自在祈祷文', '黄财神心咒', '作明佛母心咒', '莲师心咒', '意乐成就祈祷文', '金刚萨埵心咒']
    }, {
      label: '学业',
      list: ['四皈依', '绿度母心咒', '文殊心咒', '狮吼文殊心咒', '金刚萨埵心咒', '观音心咒']
    }]);
    const balance = computed(() => {
      return store.getBalance('nj');
    });
    const incantationList = ['加倍咒', '八吉祥', '吉祥云聚', '四皈依', '怀业自在祈祷文', '观音九本尊心咒', '观音菩萨名号', '观音心咒', '大悲咒', '阿弥陀佛名号', '阿弥陀佛心咒', '文武百尊心咒', '往生法', '乔美极乐愿文', '麦彭极乐愿文', '普贤行愿品', '愿海精髓', '火施仪轨', '勾招仪轨', '替身朵玛仪轨', '解脱经', '陀罗尼集', '宝积经', '文殊心咒', '妙音天女心咒', '作明佛母心咒', '清净戒律咒', '药师经', '药师佛长心咒', '药师佛短心咒', '药师佛名号', '药师八佛名号', '狮吼咒', '妙音王名号', '地藏菩萨名号', '地藏菩萨心咒', '地藏经', '臧巴拉', '招财仪轨', '五财神', '财源天母', '百字明', '金刚萨埵心咒', '三十五佛忏悔文', '无量长寿经', '长寿佛长心咒', '长寿佛短心咒', '长寿三尊心咒', '长寿仪轨', '金刚经', '般若摄颂', '般若八千颂', '般若心经', '般若佛母心咒', '心经回遮仪轨', '释迦牟尼佛心咒', '释迦牟尼佛名号', '不动佛名号', '不动佛心咒', '大白伞盖母心咒', '大白伞盖母经', '具光佛母心咒', '狮面佛母心咒', '金刚亥母心咒', '金刚七句祈祷文', '尊胜佛母长咒', '金刚手心咒', '普巴金刚心咒', '莲师心咒', '愤怒莲师心咒', '马头明王心咒', '大威德心咒', '红阎魔心咒', '愤怒女神心咒', '金刚铠甲心咒', '摧破金刚沐浴陀罗尼经', '摧破金刚心咒', '遣除道障祈祷文', '普获悉地祈祷文', '莲师意乐成就祈祷文', '意乐速成祈祷文', '法王上师瑜伽', '法王如意宝心咒', '二十一度母赞', '绿度母心咒', '白度母赞', '救八难度母仪轨', '观音文殊金刚手', '时轮金刚心咒', '缘起咒', '嗡啊吽', '随念三宝经受食仪轨', '供护法', '格萨尔王仪轨', '一髻佛母等护法仪轨', '吉祥天母仪轨', '玛哈嘎拉心咒', '玛哈嘎拉仪轨', '大鹏心咒', '普明大日如来心咒', '秽迹金刚', '白毫光明心咒', '莲师遗教经摄略', '四曼扎', '风马', '解缚咒', '文殊会供', '益西措嘉会供', '加持保佑', '发愿回向', '八大法行'];
    const showPicker = ref(false);
    const onConfirm = value => {
      showPicker.value = false;
      if (!store.nj.checkList.find(v => v.text === value)) {
        store.nj.checkList = [{
          text: value,
          canRemove: true
        }, ...store.nj.checkList];
      } else {
        Toast.fail('请勿重复添加');
      }
    };
    const clickRecommend = value => {
      const recommend = recommendList.value.find(v => v.label === value);
      if (recommend) {
        store.nj.checkList = recommend.list.map(v => {
          return {
            text: v,
            canRemove: false
          };
        });
      }
    };
    const clickRemoveAll = () => {
      store.nj.checkList = [];
      store.nj.checked = '';
    };
    const canSubmit = computed(() => {
      const {
        checkList,
        amount,
        repeat
      } = store.nj;
      return checkList.length > 0 && amount !== '' && repeat !== '' && Number(amount) > 0 && Number(repeat) > 0 && Number(repeat) <= 365;
    });
    const clickSubmit = () => {
      if (balance.value < 0) return Toast.fail('余额不足，请重新输入');
      store.nj.isFinished = true;
      Toast.success({
        message: '提交成功',
        forbidClick: true,
        duration: 1000,
        onClose: router.back
      });
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_tag = _resolveComponent("van-tag");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        onClickLeft: _unref(router).back,
        title: "念经",
        "left-arrow": ""
      }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_van_radio_group, {
        modelValue: _unref(store).nj.checked,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(store).nj.checked = $event),
        direction: "horizontal",
        onChange: clickRecommend
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendList.value, item => {
          return _openBlock(), _createBlock(_component_van_radio, {
            class: "mb-5 mr-5",
            shape: "square",
            name: item.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
            _: 2
          }, 1032, ["name"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("p", _hoisted_7, [_createElementVNode("span", {
        class: "mr-3",
        onClick: _cache[1] || (_cache[1] = $event => showPicker.value = true)
      }, "+ 添加经咒"), _createElementVNode("span", {
        onClick: clickRemoveAll
      }, "清空")])]), _createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).nj.checkList, item => {
        return _openBlock(), _createBlock(_component_van_tag, {
          class: "mr-2 mb-1",
          type: "primary",
          size: "large",
          closeable: item.canRemove,
          plain: !item.canRemove,
          onClose: $event => _unref(store).clickRemoveNj(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
          _: 2
        }, 1032, ["closeable", "plain", "onClose"]);
      }), 256))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", _hoisted_11, [_createElementVNode("span", {
        class: "mr-3",
        onClick: _cache[2] || (_cache[2] = $event => _unref(store).nj.backContent = '愿我临命欲终时，尽除一切诸障碍，面见彼佛阿弥陀，即得往生安乐刹。我既往生彼国已，现前成就此大愿，一切圆满皆无余，利乐一切众生界。彼佛众会咸清净，我时于胜莲华生，亲睹如来无量光，现前授我菩提记。蒙彼如来授记已，化身无数百俱胝，智力广大遍十方，普利一切众生界。我此普贤殊胜行，无边胜福皆回向，普愿沈溺诸众生，速往无量光佛刹。')
      }, "+ 添加回向文")])]), _createVNode(_component_van_field, {
        class: "p-0",
        modelValue: _unref(store).nj.backContent,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(store).nj.backContent = $event),
        rows: "2",
        autosize: "",
        type: "textarea",
        maxlength: "200",
        placeholder: "请输入回向内容，最多200字。",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("h1", _hoisted_13, [_createTextVNode(" 念经金额：¥ "), _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(balance)), 1), _createTextVNode(" 元 ")]), _createVNode(_component_van_form, null, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            required: "",
            type: "number",
            modelValue: _unref(store).nj.amount,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(store).nj.amount = $event),
            name: "name",
            label: "每天金额",
            placeholder: "请输入每天念经金额",
            rules: [{
              required: true,
              message: '请填写每天念经金额'
            }, {
              validator: v => v >= 1,
              message: '每天念经金额最小为1元'
            }]
          }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
            required: "",
            type: "number",
            modelValue: _unref(store).nj.repeat,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(store).nj.repeat = $event),
            name: "name",
            label: "重复天数",
            placeholder: "请输入重复天数",
            rules: [{
              required: true,
              message: '请填写重复天数'
            }, {
              validator: v => v >= 1,
              message: '重复天数至少1天'
            }, {
              validator: v => v <= 365,
              message: '重复天数不能超过365天'
            }]
          }, null, 8, ["modelValue", "rules"])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_van_button, {
        class: "submitBtn rounded-lg mt-4",
        color: "linear-gradient(45deg, #9C071E 0%, #F76F34 100%)",
        size: "large",
        disabled: !_unref(canSubmit),
        onClick: clickSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => showPicker.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: incantationList,
          onConfirm: onConfirm,
          onCancel: _cache[6] || (_cache[6] = $event => showPicker.value = false)
        })]),
        _: 1
      }, 8, ["show"])]);
    };
  }
});